<template>
<div class="container-body login-body-color">
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div
          class="card o-hidden border-0 shadow-lg my-5 login-border-radius" 
        >
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6">
                <img src="./loginPageBanner.png" class="login-logo" alt="logo"/>
              </div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      {{ $t("CHANGEPASSWORD") }}
                    </h1>
                  </div>
                  <br />
                   <br />
                  <form class="user">
                    <div class="form-group">
                      <input
                        type="password"
                        class="form-control form-control-user"
                        id="password"
                        v-model.trim="$v.form.password.$model"
                        :placeholder="$t('NEWPASSWORD')"
                        autocomplete="off"
                      />
                      <show-errors
                        :control="$v.form.password"
                        :field="$t('MANDATORY')"
                      />
                    </div>
                    <div class="form-group">
                      <input
                        type="password"
                        v-model.trim="$v.form.password_confirmation.$model"
                        class="form-control form-control-user"
                        id="password_confirmation"
                        :placeholder="$t('CONFIRMPASSWORD')"
                        autocomplete="off"
                      />
                      <show-errors
                        :control="$v.form.password_confirmation"
                        :field="$t('IDENTICALPASSWORD')"
                      />
                    </div>
                    
                    <button
                      class="btn btn-primary btn-user btn-block"
                      @click="changepassword"
                      type="button"
                    >
                      {{ $t("CHANGE") }}
                      <span
                        v-if="submitted"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Loading...</span>
                    </button>
                    <div class="form-group text-center">
                    
                    </div>
                    <br />
                    <br />
                    <br />
                  </form>
                  
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  required,
  sameAs,
  helpers
} from "vuelidate/lib/validators";
import ShowErrors from "../../../components/ShowErrors";
import { mapGetters } from "vuex";
import { RESET_PASSWORD_EXISTING } from "@/store/actions.type";
const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{10,}$/;
const specialPassword = helpers.regex("specialPassword", regex);

export default {
  name: "FirstTimeLogin",
  components: { ShowErrors },
  data() {
    return {
      isUser:true,
      paramToken: "",
      form: {
        password: "",
        password_confirmation: ""
      },
      submitted: false
    };
  },
  validations: {
    form: {
      password: {
        required,
        specialPassword
      },
      password_confirmation: {
        sameAsPassword: sameAs("password")
      }
    }
  },
  methods: {
  async  changepassword() {
      console.log("this.form", this.form);
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.form.$invalid) {
        console.log("this.form", this.form);
        this.$store
          .dispatch(RESET_PASSWORD_EXISTING, {
            token: this.params.token,
            password: this.form.password
          })
          .then(data => {
            this.submitted = false;
            if (data.status) {
               if(data.end_user == false){
                 this.$router.push("/login");
                }
               
              this.$toast.success({
                message: data.message
               
              });
              
            } else {
              this.$toast.error({
                message: data.message
              });
            }
          });
      } else {
        this.submitted = false;
      }
      /* If valid it will navigate to dashboard */
      // this.$router.push("/dashboard");
    }
  },
  created() {
    this.$toast.removeAll();
    this.params = this.$route.params;
    if (_.get(this.params, "token", 0)) {
      let token = this.params.token;
      console.log("token", token);
      this.paramToken = token;
    }
 
    console.log("form", this.form);
  },
  computed: {
    ...mapGetters([""])
  }
};
</script>
<style>
.IconLogo {
  height: 18%;
  margin: 5%;
}
.container-body {
            position: absolute;
            width: 100%;
            min-height: 100%;
            left: 0;
            top: 0;
        }
</style>
